var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1386,
    height: 802,
    viewBox: "0 0 1386 802",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10033_38372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1386 0H0V802H1386V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 533.33L38.5 547.098C77 560.999 154 588.534 231 605.51C308 622.486 385 628.634 462 620.882C539 613.129 616 591.208 693 597.757C770 604.173 847 638.927 924 637.59C1001 636.253 1078 598.827 1155 572.494C1232 546.296 1309 531.058 1347.5 523.572L1386 515.953V803.337H1347.5C1309 803.337 1232 803.337 1155 803.337C1078 803.337 1001 803.337 924 803.337C847 803.337 770 803.337 693 803.337C616 803.337 539 803.337 462 803.337C385 803.337 308 803.337 231 803.337C154 803.337 77 803.337 38.5 803.337H0V533.33Z",
    fill: "#FAFAFA",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 711.107L38.5 712.176C77 713.379 154 715.518 231 711.107C308 706.696 385 695.468 462 681.967C539 668.333 616 652.293 693 650.288C770 648.283 847 660.313 924 683.304C1001 706.161 1078 740.112 1155 746.261C1232 752.543 1309 731.157 1347.5 720.463L1386 709.77V803.337H1347.5C1309 803.337 1232 803.337 1155 803.337C1078 803.337 1001 803.337 924 803.337C847 803.337 770 803.337 693 803.337C616 803.337 539 803.337 462 803.337C385 803.337 308 803.337 231 803.337C154 803.337 77 803.337 38.5 803.337H0V711.107Z",
    fill: "#F3F3F3",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.4805 712.501L-32.5032 705.042C4.47412 697.584 78.4287 682.667 152.383 695.113C226.338 707.373 300.292 747.461 374.247 769.696C448.202 792.211 522.156 796.872 596.111 787.083C670.065 777.294 744.02 752.123 817.975 739.863C891.929 727.417 965.884 727.417 1039.84 729.888C1113.79 732.545 1187.75 737.206 1261.7 744.804C1335.66 752.123 1409.61 762.378 1483.57 769.696C1557.52 777.294 1631.48 781.956 1668.45 784.613L1705.43 787.083V802H1668.45C1631.48 802 1557.52 802 1483.57 802C1409.61 802 1335.66 802 1261.7 802C1187.75 802 1113.79 802 1039.84 802C965.884 802 891.929 802 817.975 802C744.02 802 670.065 802 596.111 802C522.156 802 448.202 802 374.247 802C300.292 802 226.338 802 152.383 802C78.4287 802 4.47412 802 -32.5032 802H-69.4805V712.501Z",
    fill: "url(#paint0_linear_10033_38372)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10033_38372",
    x1: 872.863,
    y1: 851.913,
    x2: 894.706,
    y2: 986.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F5F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10033_38372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 802,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave4);
export default __webpack_public_path__ + "static/media/wave4.0b97c5cd9a054b556def0226650cd027.svg";
export { ForwardRef as ReactComponent };